import { Note } from "@vita-learning/types";

export const NOTE_SOURCES: Note["source"][] = [
	"manual",
	"file",
	"prompt",
	"url",
];
